import { IslandContext } from 'pages/Islands/IslandPage/context/IslandContext'
import { useContext } from 'react'

export const useIslandContext = () => {
  const context = useContext(IslandContext)
  if (!context) {
    throw new Error('useIslandContext must be used within an IslandProvider')
  }
  return context
}
